import React from "react";
import Link from "../atoms/Link";
import { OpenModal } from "./Modal";
import contentfulRichText from "../util/contentfulRichText";
import Image from "../atoms/Image";

export default ({ title, image, description, link, modalText, modalImage, modalReadMore = "Read more", translations }) => {

  const modalContent = (
    <>
      { modalImage ? <Image image={ modalImage }/> : <Image image={ image }/> }
      <div className="o-modal__content o-modal__content--bg">
        { contentfulRichText(modalText) }
        { link &&
          <Link className="o-offer__link" link={ link } translations={ translations }/>
        }
      </div>
    </>
  )

  return (
    <div className="o-offer">
      <div className="u-object-fit u-object-fit--16-9">
        <Image className="o-offer__image u-object-fit__media" image={ image }/>
      </div>
      <div className="o-offer__content">
        <div className="o-offer__title heading heading--fsb">{ title }</div>
        <p className="o-offer__text u-small-text">{ description }</p>
        { (link && !modalText) && <Link className="o-offer__link" link={ link } translations={ translations }/> }
        { modalText &&
          <OpenModal className="o-offer__link" readMore={ modalReadMore } modalContent={ modalContent } />
        }
      </div>
    </div>
  );
}

